import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { getBehalfOf, getUsernameById } from "../../../api/systemUserApi";
import SearchDropdown from "../../input/SearchDropdown";
import Dropdown from "../../input/Dropdown";
import {
  getBulkDropdownData,
  getDropdownData,
  getTextByValueAndKey,
} from "../../../api/keyvalue";
import Input from "../../input/Input";
import Button from "../../input/Button";
import Grid from "../../Grid";
import ButtonRenderer from "../../renderer/ButtonRenderer";
import {
  approveDetailsValidation,
  itemCreationValidation,
} from "../../validations/DeductionCreation";
import { toast } from "react-toastify";
import { getAllRoles, getRoleById } from "../../../api/rolesApi";
import { ResizableScrollingTextRenderer } from "../../renderer/StyleRenderer";
import { errorActions } from "../../../store/error-slice";
import {useDispatch, useSelector} from "react-redux";
import { approvalUserFindByUserId } from "../../../api/ApprovalMasterApi";
import useUserCompany from "../../../hooks/useUserCompany";
import InfoList from "../../InfoList";
import { formatFromJsonDate } from "../../../dateConfig";
import { User } from "react-feather";
import DeleteButtonRenderer from "../../renderer/DeleteButtonRenderer";

const ApprovalMasterDetailsForm = forwardRef(
  (
    {
      dropdown,
      isLoading,
      currentValues,
      currentHeaderValue,
      editMode,
      approvalTypes,
      headerAudit,
    },
    ref
  ) => {
    const errorState = useSelector(
        (state) => state.error.deductApprovalDetailErrors
    );

    const [currentErrors, setCurrentErrors] = useState(errorState?.deductApprovalDetailErrors);
    useEffect(() => {
      setCurrentErrors(errorState.deductApprovalDetailErrors);
    }, [errorState]);

    const dispatch = useDispatch();
    const userCompany = useUserCompany();

    const [company, setCompany] = useState(
      userCompany ? userCompany.comId : null
    );
    useEffect(() => {
      setCompany(userCompany ? userCompany.comId : null);
    }, [userCompany]);

    const [approvalDetailData, setApprovalDetailData] = useState(
      editMode
        ? {
            // ...currentValues,
            apdSeq: 1,
            apdName: "",
            userPermission: "",
            apdCompany: company,
          }
        : {
            apdCode: "",
            apdReference: "",
            apdCompany: company,
            apdName: "",
            apdAppId: "",
            apdUser: "",
            apdDepartments: "",
            apdRole: "",
            apdDescription: "",
            apdSeq: "",
            apdStatus: 2,
            apdActive: 1,
            userPermission: "",
          },
    );

    const [approvalDetail, setApprovalDetail] = useState([]);
    const [deletedList, setDeletedList] = useState([]);
    const [currentApprovalDetail, setCurrentApprovalDetail] = useState({});

    // flags
    const [searchFieldReset, setSearchFieldReset] = useState(false);
    const [isAddLoading, setIsAddLoading] = useState(false);
    const [buttonClicked, setButtonClicked] = useState(false);
    const [currentApprovalDetailEdit, setCurrentApprovalDetailEdit] =
      useState(false);
    const [levelNameStatus, setLevelNameStatus] = useState(false);

    // dropdown
    const [departmentOpt, setDepartmentOpt] = useState([]);
    const [roleOpt, setRoleOpt] = useState([]);

    //counter
    const [approvalDetailCount, setApprovalDetailCount] = useState(2);
    const [count, setCount] = useState(editMode ? currentValues.length - 1 : 0);

    useEffect(() => {
      (async () => {
        //new

        const { departments: departmentsOpt } = await getBulkDropdownData([
          { key: "departments" },
        ]);

        setDepartmentOpt(departmentsOpt);

        const roles = await getAllRoles();
        setRoleOpt(roles);
      })();
    }, []);

    useEffect(() => {
      (async () => {
        if (editMode && currentValues) {
          let currentApprovalDetails = [];
          let id = 2;
          for (let currentValue of currentValues) {
            const department = await getTextByValueAndKey(
              "departments",
              currentValue.apdDepartments,
            );

            const username = await getUsernameById(currentValue.apdUser);

            const role = await getRoleById(currentValue.apdRole);

            currentApprovalDetails.push({
              ...currentValue,
              user: username,
              department: department,
              role: role?.rolRole,
              id,
            });

            ++id;
          }
          setApprovalDetailCount(id);
          currentApprovalDetails.sort((a, b) => a.apdSeq - b.apdSeq);
          setApprovalDetail(currentApprovalDetails);
        }
      })();
    }, [editMode, currentValues]);

    const onAddClick = async () => {
      setIsAddLoading(true);
      try {
        const approvalDetailError = approveDetailsValidation({
          ...approvalDetailData,
        });
        if (Object.keys(approvalDetailError).length > 0) {
          dispatch(
              errorActions.validateDeductApprovalDetailCreation({
                deductAppData: approvalDetailError,
              })
          );
          setIsAddLoading(false);
          toast.error("There was an error adding Approval", {
            autoClose: 5000,
            containerId: "Main",
          });
          return;
        } else if (Object.keys(approvalDetailError).length === 0) {
          const response = editMode ? await approvalUserFindByUserId(
            approvalDetailData.apdUser,
            currentHeaderValue?.appId,
              company
          ) : null;
          if (
            Object.keys(currentApprovalDetail).length === 0 &&
            approvalDetail.some(
              (user) => user?.apdUser === approvalDetailData.apdUser,
            )
          ) {
            toast.error(
              "There was an error adding approval user already added to grid!",
              { autoClose: 5000, containerId: "Main" },
            );
          } else if (editMode && !approvalDetailData.id && response !== "") {
            toast.error(
              "There was an error adding approval user already exists!",
              {
                autoClose: 5000,
                containerId: "Main",
              },
            );
          } else {
            const department = await getTextByValueAndKey(
              "departments",
              approvalDetailData.apdDepartments,
            );
            const username = await getUsernameById(approvalDetailData.apdUser);

            const role = await getRoleById(approvalDetailData.apdRole);

            if (!approvalDetailData.apdId) {
              if (!approvalDetailData.id) {
                if (approvalDetail.length > 0) {
                  if (
                    approvalDetailData.apdSeq.toString() ===
                      approvalDetail[count].apdSeq.toString() ||
                    parseInt(approvalDetail[count].apdSeq) + 1 ===
                      parseInt(approvalDetailData.apdSeq) ||
                    parseInt(approvalDetail[count].apdSeq) >=
                      parseInt(approvalDetailData.apdSeq)
                  ) {
                    setApprovalDetail((prevState) => [
                      ...prevState,
                      {
                        ...approvalDetailData,
                        apdSeq: editMode
                          ? parseInt(approvalDetailData.apdSeq)
                          : approvalDetailData.apdSeq,
                        user: username,
                        department: department,
                        role: role,
                        id: approvalDetailCount,
                      },
                    ]);
                    setApprovalDetailCount((prevState) => ++prevState);
                    setCount((prevCount) => prevCount + 1);
                  } else {
                    toast.error("Please enter approval levels as sequence!", {
                      autoClose: 5000,
                      containerId: "Main",
                    });
                  }
                } else {
                  if (approvalDetailData.apdSeq.toString() === "1") {
                    setApprovalDetail((prevState) => [
                      ...prevState,
                      {
                        ...approvalDetailData,
                        // apdSeq:
                        user: username,
                        department: department,
                        role: role,
                        id: approvalDetailCount,
                      },
                    ]);
                    setApprovalDetailCount((prevState) => ++prevState);
                  } else {
                    toast.error("Please enter approval levels 1 as first!", {
                      autoClose: 5000,
                      containerId: "Main",
                    });
                  }
                }
              } else {
                setApprovalDetail((prevState) =>
                  prevState.filter(
                    (approve) => approve.id !== approvalDetailData.id,
                  ),
                );
                setApprovalDetail((prevState) => [
                  ...prevState,
                  {
                    ...approvalDetailData,
                    apdSeq: parseInt(approvalDetailData.apdSeq),
                    user: username,
                    department: department,
                    role: role,
                  },
                ]);
              }
            } else {
              if (
                approvalDetailData.apdSeq.toString() ===
                  approvalDetail[count].apdSeq.toString() ||
                parseInt(approvalDetail[count].apdSeq) + 1 ===
                  parseInt(approvalDetailData.apdSeq) ||
                parseInt(approvalDetail[count].apdSeq) >=
                  parseInt(approvalDetailData.apdSeq)
              ) {
                setApprovalDetail((prevState) =>
                  prevState.filter(
                    (approve) => approve.apdId !== approvalDetailData.apdId,
                  ),
                );
                setApprovalDetail((prevState) => [
                  ...prevState,
                  {
                    ...approvalDetailData,
                    apdSeq: parseInt(approvalDetailData.apdSeq),
                    user: username,
                    department: department,
                    role: role,
                    modified: true,
                  },
                ]);
                dispatch(errorActions.clearDeductApprovalDetailError());
              } else {
                toast.error("Please enter approval levels as sequence!", {
                  autoClose: 5000,
                  containerId: "Main",
                });
              }
            }
            setButtonClicked(true);
          }
          setCurrentErrors(approvalDetailError);
          setIsAddLoading(false);
        } else {
          setIsAddLoading(false);
          Object.values(approvalDetailError).forEach((error) => {
            toast.error(error, { autoClose: 5000, containerId: "Main" });
          });
        }
      } catch (e) {
        toast.error("Error Occurred!", {
          autoClose: 5000,
          containerId: "Main",
        });
        console.error(e);
      } finally {
        setIsAddLoading(false);
      }
      setIsAddLoading(false);
    };
    useEffect(() => {
      if (buttonClicked) {
        setApprovalDetailData({
          apdCode: "",
          apdReference: "",
          apdCompany: "",
          apdName: "",
          apdAppId: "",
          apdUser: "",
          apdDepartments: "",
          apdRole: "",
          apdDescription: "",
          apdSeq: 1,
          apdStatus: 2,
          apdActive: 1,
          userPermission: "",
        });
        setButtonClicked(false);
        setSearchFieldReset(true);
        setCurrentApprovalDetailEdit(false);
        setCurrentErrors({});
        setCurrentApprovalDetail({});
      }
    }, [buttonClicked]);

    useEffect(() => {
      if (Object.keys(currentApprovalDetail).length > 0) {
        setApprovalDetailData({
          ...currentApprovalDetail,
        });
        setCurrentApprovalDetailEdit(true);
      }
    }, [editMode, currentApprovalDetail]);

    useImperativeHandle(ref, () => ({
      getData: () => {
        //
        if (editMode) {
          const updateState = {
            modified: [],
            unmodified: [],
            created: [],
            deleted: deletedList,
          };
          approvalDetail.forEach((apd) => {
            if (apd.apdId && apd.apdId !== null) {
              if (apd.modified) {
                updateState.modified.push(apd);
              } else {
                updateState.unmodified.push(apd);
              }
            } else {
              updateState.created.push(apd);
            }
          });
          return updateState;
        } else {
          return approvalDetail;
        }
      },
      resetForm: () => {
        setApprovalDetailData({});
        setApprovalDetail([]);
        setCurrentErrors({});
      },
    }));

    const addSeqLevelName = (seq) => {
      if (approvalTypes === 3) {
        const foundItem = approvalDetail.find(
          (item) => Number(item.apdSeq) === Number(seq),
        );

        if (foundItem) {
          setApprovalDetailData((prevState) => ({
            ...prevState,
            apdName: foundItem.apdName,
          }));
          setLevelNameStatus(true);
        } else {
          setLevelNameStatus(false);
        }
      }
    };

    return (
      <>
        <form className="ui form">
          <div className="ui segment">
            <h4 className="ui dividing header">Approve Levels</h4>
            <div className="three fields ui segment">
              <SearchDropdown
                key={1}
                disabled={
                  approvalDetailData.apdRole ||
                  approvalDetailData.apdDepartments
                }
                // threshold={1}
                editMode={editMode}
                multiGrid={true}
                multiGridCurrentValue={approvalDetailData.user}
                reset={searchFieldReset}
                setReset={setSearchFieldReset}
                clearable={true}
                api={getBehalfOf}
                apiDependency={{
                  customer: null,
                  shipper: null,
                }}
                onResultSelect={(data) =>
                  setApprovalDetailData((prevState) => ({
                    ...prevState,
                    apdUser: data,
                    userPermission: data,
                  }))
                }
                onClear={() => {
                  setApprovalDetailData((prevState) => ({
                    ...prevState,
                    userPermission: null,
                    apdUser: null,
                  }));
                }}
                error={currentErrors.userPermission}
                resetError={() => {
                  setCurrentErrors((prevState) => {
                    const { userPermission: _, ...rest } = prevState;
                    return rest;
                  });
                  setCurrentErrors((prevState) => {
                    const { apdUser: _, ...rest } = prevState;
                    return rest;
                  });
                }}
                label="User"
              />

              <Dropdown
                disabled={
                  approvalDetailData.apdRole || approvalDetailData.apdUser
                }
                label="Department"
                error={currentErrors.userPermission}
                resetError={() => {
                  setCurrentErrors((prevState) => {
                    const { userPermission: _, ...rest } = prevState;
                    return rest;
                  });
                  setCurrentErrors((prevState) => {
                    const { apdDepartments: _, ...rest } = prevState;
                    return rest;
                  });
                }}
                placeholder="Department"
                options={departmentOpt}
                value={approvalDetailData.apdDepartments}
                style={{ height: "5px" }}
                onChange={(e, data) => {
                  setApprovalDetailData((prevState) => ({
                    ...prevState,
                    apdDepartments: data.value,
                    userPermission: data.value,
                  }));
                }}
              />

              <Dropdown
                disabled={
                  approvalDetailData.apdDepartments ||
                  approvalDetailData.apdUser
                }
                label="Role"
                // error={currentErrors.apdRole}
                error={currentErrors.userPermission}
                resetError={() => {
                  setCurrentErrors((prevState) => {
                    const { userPermission: _, ...rest } = prevState;
                    return rest;
                  });
                  setCurrentErrors((prevState) => {
                    const { apdRole: _, ...rest } = prevState;
                    return rest;
                  });
                }}
                placeholder="Role"
                options={roleOpt}
                value={approvalDetailData.apdRole}
                style={{ height: "5px" }}
                onChange={(e, data) => {
                  setApprovalDetailData((prevState) => ({
                    ...prevState,
                    apdRole: data.value,
                    userPermission: data.value,
                  }));
                }}
              />
            </div>
            <div className="three fields">
              <Input
                required={true}
                label="Approval Level"
                type="number"
                min="1"
                placeholder="1"
                error={currentErrors.apdSeq}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { apdSeq: _, ...rest } = prevState;
                    return rest;
                  })
                }
                name="Sequence"
                value={approvalDetailData.apdSeq}
                onChange={(e) => {
                  setApprovalDetailData((prevState) => ({
                    ...prevState,
                    apdSeq: e.target.value,
                    apdName: "",
                  }));
                  addSeqLevelName(e.target.value);
                }}
              />
            </div>
            <div className="two fields">
              <Input
                label="Name"
                required={true}
                placeholder="Name"
                error={currentErrors.apdName}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { apdName: _, ...rest } = prevState;
                    return rest;
                  })
                }
                name="name"
                value={approvalDetailData.apdName}
                onChange={(e) => {
                  setApprovalDetailData((prevState) => ({
                    ...prevState,
                    apdName: e.target.value,
                  }));
                }}
                disabled={levelNameStatus}
              />
              <Input
                label="Description"
                placeholder="Description"
                error={currentErrors.apdDescription}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { apdDescription: _, ...rest } = prevState;
                    return rest;
                  })
                }
                name="Description"
                value={approvalDetailData.apdDescription}
                onChange={(e) => {
                  setApprovalDetailData((prevState) => ({
                    ...prevState,
                    apdDescription: e.target.value,
                  }));
                }}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "flex-end",
            }}
          >
            <Button
              template="reset"
              onClick={(e) => {
                setButtonClicked(true);
              }}
            />
            <Button
              template="addOrSave"
              create={Object.keys(currentApprovalDetail).length === 0}
              onClick={onAddClick}
              isLoading={isAddLoading}
            />
          </div>
          <small style={{ color: "#9f3a38" }}>{`${
            currentErrors.mainCountError ? currentErrors.mainCountError : ""
          }`}</small>
          <Grid
            heading="Approve Details List"
            config={[
              // { headerName: "Code", field: "excCode" },
              { headerName: "User", field: "user" },
              { headerName: "Department", field: "department" },
              { headerName: "Role", field: "role" },
              { headerName: "Approval Level", field: "apdSeq" },
              { headerName: "Name", field: "apdName" },
              {
                headerName: "Description",
                field: "apdDescription",
                cellRenderer: ResizableScrollingTextRenderer,
              },
              {
                field: "Edit",
                filter: true,
                cellRenderer: ButtonRenderer,
                cellRendererParams: (params) => ({
                  clickHandler: () => {
                    dispatch(errorActions.clearShiftDetailsError());
                    setCurrentApprovalDetail(params.data);
                  },
                  label: "Edit",
                  disabled: editMode
                }),
              },
              {
                field: "Delete",
                filter: true,
                cellRenderer: DeleteButtonRenderer,
                cellRendererParams: (params) => ({
                  clickHandler: () => {
                    if (params.data.apdId && params.data.apdId !== null) {
                      setDeletedList((prevState) => [
                        ...prevState,
                        params.data.apdId,
                      ]);
                    }
                    setApprovalDetail((prevState) =>
                      prevState.filter(
                        (approve) => approve.id !== params.data.id,
                      ),
                    );
                  },
                  message:
                          "Are you sure you want to delete this Approval Detail?",
                  label: "Delete",
                  className: "ui red button",
                }),
              },
            ]}
            content={approvalDetail}
          />
          {editMode && (
            <InfoList
              title="User Information"
              content={[
                {
                  title: "Created By",
                  value: headerAudit?.createdBy
                    ? headerAudit?.createdBy
                    : "N/A",
                },
                {
                  title: "Created Date",
                  value: headerAudit?.createdDate
                    ? formatFromJsonDate(headerAudit?.createdDate)
                    : "N/A",
                },
                {
                  title: "Last Modified By",
                  value: headerAudit?.lastModifiedBy
                    ? headerAudit?.lastModifiedBy
                    : "N/A",
                },
                {
                  title: "Last Modified Date",
                  value: headerAudit?.lastModifiedDate
                    ? formatFromJsonDate(headerAudit?.lastModifiedDate)
                    : "N/A",
                },
              ]}
              Icon={User}
            />
          )}
        </form>
      </>
    );
  },
);

export default ApprovalMasterDetailsForm;
